module.exports = __webpack_public_path__ + "img/print.5aec4d56.png";